<div class="external" id="main">
  <div class="section" id="login">
    <div class="content-body">
      <div class="content">
        <div class="title">
          <h1>{{ "login.title" | translate }}</h1>
        </div>
        <form [formGroup]="form" class="form">
          <div class="fieldset">
            <p-select
              [options]="ships"
              [readonly]="shipId"
              [style]="{'width': '100%'}"
              formControlName="shipId"
              optionLabel="name"
              optionValue="id"
              placeholder="{{ 'login.select_ship' | translate }}"
            />
          </div>
          <div class="fieldset">
            <p-floatLabel>
              <input formControlName="username" id="username" pInputText type="text" />
              <label for="username">{{ "login.placeholder_card" | translate }}</label>
            </p-floatLabel>
          </div>
          <div class="fieldset">
            <p-floatLabel>
              <p-inputMask formControlName="password" mask="99/99/9999" inputId="password" />
              <label for="password">{{ "login.placeholder_pass" | translate }}</label>
            </p-floatLabel>
          </div>
        </form>
      </div>
      <div class="login-buttons">
        <button (click)="SingIn()" [disabled]="!form.valid" class="costa-button" type="button">
          {{ "login.title" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
